import React from 'react'

const BoltOutlinedIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='35'
    height='35'
    viewBox='0 0 35 35'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15.3851 26.5416L22.932 17.5H17.0986L18.1559 9.22392L11.4111 18.9583H16.4788L15.3851 26.5416ZM11.6663 32.0833L13.1247 21.875H5.83301L18.958 2.91663H21.8747L20.4163 14.5833H29.1663L14.583 32.0833H11.6663Z'
      fill='currentColor'
    />
  </svg>
)

export default BoltOutlinedIcon
